<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <mat-checkbox
            [formControl]="control"
            [attr.formcontrolname]="field.name"
            [required]="isRequired"
            [id]="field.id"
            (change)="checkboxChange($event)"
            [ngClass]="{ 'custom-checkbox': true }"
        >
            {{ field.placeholder | translate }}
        </mat-checkbox>
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
